import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/c/$identifier")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/clubs/$identifier",
      params: { identifier: params.identifier },
    });
  },
});
